export default __webpack_public_path__ + "static/media/2-2.598771dc.mp3";